import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
const plans = [{
  name: 'Starter Scroll',
  price: '€1,200',
  period: '/month',
  description: 'Perfect for schools and small EdTech startups getting started',
  features: ['Content strategy consultation', '8 blog posts per month', 'Social media calendar', 'Monthly performance report', 'Email support'],
  color: 'from-purple-400 to-purple-600',
  popular: false
}, {
  name: 'Hero Bundle',
  price: '€2,800',
  period: '/month',
  description: 'Most popular for growing educational brands',
  features: ['Everything in Starter Scroll', 'School outreach campaigns', 'Email marketing campaigns', 'SEO optimization', '16 blog posts per month', 'Bi-weekly strategy calls', 'Priority support'],
  color: 'from-pink-400 to-pink-600',
  popular: true
}, {
  name: 'Legend Pack',
  price: '€5,500',
  period: '/month',
  description: 'Full-service solution for established organizations',
  features: ['Everything in Hero Bundle', 'Video content creation', 'Event marketing support', 'Custom analytics dashboard', 'Dedicated account manager', 'Weekly strategy sessions', 'Unlimited revisions', '24/7 priority support'],
  color: 'from-blue-400 to-blue-600',
  popular: false
}];
export function Pricing() {
  return <section id="pricing" className="py-20 px-4 bg-gradient-to-br from-yellow-50 to-purple-50" data-id="element-150">
      <div className="max-w-7xl mx-auto" data-id="element-151">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-152">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-153">
            Choose Your Adventure
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-154">
            Flexible pricing plans designed for educational organizations of all
            sizes
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-155">
          {plans.map((plan, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} whileHover={{
          y: -8
        }} className={`relative bg-white rounded-3xl p-8 shadow-xl ${plan.popular ? 'ring-4 ring-pink-400' : ''}`} data-id="element-156">
              {plan.popular && <div className="absolute -top-4 left-1/2 transform -translate-x-1/2" data-id="element-157">
                  <div className="bg-gradient-to-r from-pink-400 to-pink-600 text-white px-6 py-2 rounded-full font-bold flex items-center gap-2 shadow-lg" data-id="element-158">
                    <Star size={16} fill="white" data-id="element-159" />
                    Most Popular
                  </div>
                </div>}

              <div className={`bg-gradient-to-r ${plan.color} rounded-2xl p-6 mb-6 text-white`} data-id="element-160">
                <h3 className="text-2xl font-bold mb-2" data-id="element-161">{plan.name}</h3>
                <div className="flex items-baseline gap-1" data-id="element-162">
                  <span className="text-5xl font-bold" data-id="element-163">{plan.price}</span>
                  <span className="text-xl opacity-90" data-id="element-164">{plan.period}</span>
                </div>
              </div>

              <p className="text-gray-600 mb-6" data-id="element-165">{plan.description}</p>

              <ul className="space-y-4 mb-8" data-id="element-166">
                {plan.features.map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-167">
                    <div className="bg-green-100 rounded-full p-1 mt-0.5" data-id="element-168">
                      <Check size={16} className="text-green-600" data-id="element-169" />
                    </div>
                    <span className="text-gray-700" data-id="element-170">{feature}</span>
                  </li>)}
              </ul>

              <button className={`w-full bg-gradient-to-r ${plan.color} text-white py-4 rounded-full font-bold text-lg hover:shadow-xl transition-all transform hover:scale-105`} data-id="element-171">
                Get Started
              </button>
            </motion.div>)}
        </div>
      </div>
    </section>;
}